












































































































































import { Component, Mixins } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { DataModules } from "@/store/modules/data";
import { FilterOperators, FilterTypes } from "@/data/table";
import { ImportStatusCodes as ISC } from "@/data/enums/imports";
import { IImport } from "@/models/imports";
import _ from "@/boot/lodash";

@Component
export default class ImportsTable extends Mixins(FilteringSortingTableStore) {
  public defaults = {
    limit: 5
  };

  public filters: IFilter[] = [
    {
      key: "status.code",
      label: this.$t("_.status"),
      type: FilterTypes.SELECT_CHECKBOX,
      options: [
        { value: ISC.PENDING, label: this.$t("_.pending") },
        { value: ISC.EXPORTING, label: this.$t("_.exporting") },
        { value: ISC.MAPPINGS_REQUIRED, label: this.$t("_.mappings_required") },
        { value: ISC.IN_PROGRESS, label: this.$t("_.in_progress") },
        { value: ISC.CANCELLED, label: this.$t("_.cancelled") },
        { value: ISC.ERROR, label: this.$t("_.error") },
        { value: ISC.STAGED, label: this.$t("_.staged") },
        { value: ISC.COMPLETE, label: this.$t("_.complete") }
      ],
      operator: FilterOperators.EQUAL
    },
    {
      key: "credentials.url",
      label: this.$t("_.source"),
      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL
    },
    {
      key: "created_at",
      label: this.$t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "created_at",
      label: this.$t("_.date_added")
    }
  ];

  public dataModule = DataModules.IMPORTS;

  public get canDelete() {
    return this.$userCan("delete_import");
  }

  // Override mixin method
  public getStoreParams(params: any): Promise<any> {
    const defaultParams = {
      with: ["credentials", "status", "source"].join()
    };
    return _.merge({ params: defaultParams }, params);
  }

  public created() {
    if (!this.$userCan("list_imports")) return;
    this.getData();
  }

  public getImportRoute(importId: IImport["id"]) {
    return {
      name: "adminImport",
      params: {
        importId
      }
    };
  }

  public async deleteImport(importId) {
    const deleted = await this.$store.dispatch(
      `data/${DataModules.IMPORTS}/confirmDelete`,
      { importId }
    );
    if (deleted) this.getData({ ignoreStored: true });
  }

  public startingMessage(i) {
    if (!i.started_at) return { label: "--", showDate: false };
    return this.$moment(i.started_at)
      .local()
      .isAfter(new Date())
      ? { label: "Starts", showDate: true }
      : { label: "Started", showDate: true };
  }

  public getHostName(imports) {
    return imports?.credential?.hostname || imports?.name || "";
  }
}
